<template>
  <div id="vimeo-live-session-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-3">
                    <label for>
                      {{$t('components.vimeoLiveSessionAddUpdate.coverPhoto')}}
                      <br />
                      <p style="color: gray">
                        {{$t('components.vimeoLiveSessionAddUpdate.photoSize')}}
                      </p>
                    </label>
                    <el-upload
                      :onProgress="logoProgress"
                      class="avatar-uploader"
                      :action="
                        axios.defaults.baseURL +
                        'event/uploadImage?uploadType=liveEvent&language='+$i18n.locale
                      "
                      :headers="{
                        Authorization: axios.defaults.headers['Authorization'],
                      }"
                      :show-file-list="false"
                      :on-success="logoSuccess"
                    >
                      <img
                        v-if="form.image"
                        :src="form.image"
                        style="height: 200px"
                        class="avatar"
                      />
                      <i v-else class="fas fa-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <span class="error">{{
                      $errorMessage("image", validationErrors)
                    }}</span>

                    <el-progress
                      :percentage="logoPercent"
                      v-if="logoPercent != 0"
                    ></el-progress>
                    <div
                      v-if="$store.state.scenes.items.length == 0"
                      style="
                        width: 100%;
                        height: 200px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                      "
                    >
                      <span>{{ this.$t('message.noStageDesign') }}</span>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="sceneModal = true"
                        >{{$t('components.vimeoLiveSessionAddUpdate.manage')}}</el-button
                      >
                    </div>

                    <div>
                      <el-carousel
                        indicator-position="none"
                        ref="carousel"
                        :interval="5000"
                        arrow="never"
                        :autoplay="false"
                        :loop="false"
                      >
                        <el-carousel-item
                          v-for="(item) in $store.state.scenes.items"
                          :key="item.id"
                        >
                          <div class="scenes" style="cursor: pointer">
                            <div class="scene-wrapper">
                              <div
                                @click="sceneModal = true"
                                class="scene"
                                :style="
                                  'background-image: url(' +
                                  item.background +
                                  ');'
                                "
                              >
                                <div
                                  class="banner"
                                  :style="
                                    'background-image: url(' + item.top + ');'
                                  "
                                ></div>
                                <span
                                  style="
                                    font-size: 15px;
                                    font-weight: bold;
                                    color: white;
                                    text-shadow: 0px 0px 8px rgba(0, 0, 0, 1);
                                    display: block;
                                    background-color: rgba(0, 0, 0, 0.5);
                                    width: 100%;
                                    text-align: center;
                                  "
                                  >{{ item.title }}</span
                                >
                                <div
                                  class="banner"
                                  :style="
                                    'background-image: url(' +
                                    item.bottom +
                                    ');'
                                  "
                                ></div>
                              </div>
                              <el-button-group
                                :key="item.id + form.sceneID"
                                style="
                                  width: 100%;
                                  background-color: #fff;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  padding-top: 10px;
                                "
                              >
                                <el-button
                                  size="mini"
                                  @click="$refs.carousel.prev()"
                                  ></el-button>
                                <el-button
                                  size="mini"
                                  type="primary"
                                  @click="$set(form, 'sceneID', item.id)"
                                >
                                  {{
                                    form.sceneID == item.id ? $t('event.buttons.selected') : $t('event.buttons.select_')
                                  }}
                                </el-button>
                                <el-button
                                  size="mini"
                                  @click="$refs.carousel.next()"
                                  >></el-button
                                >
                              </el-button-group>
                            </div>
                          </div>
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="row">
                      <div class="col-md-6">
                        <label style="display: block">{{this.$t('event.table.title')}}</label>
                        <el-input v-model="form.title"></el-input>
                        <span class="error">{{
                          $errorMessage("title", validationErrors)
                        }}</span>
                      </div>

                      <div class="col-md-6">
                        <ActionableLabel
                          :title="$t('event.table.checkpoint')"
                          @refresh="$store.dispatch('getVenues')"
                          @new="addVenueModal = true"
                        />
                        <el-select v-model="form.venueID" clearable>
                          <el-option
                            v-for="item in $store.state.venues.items"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <span class="error">{{
                          $errorMessage("venueID", validationErrors)
                        }}</span>
                      </div>

                      <div class="col-md-12" style="margin-top: 15px">
                        <label style="display: block"
                          >{{this.$t("event.tags.startEndDate")}}</label
                        >
                        <el-date-picker 
                        :format="datePickerDisplayFormat()" 
                          v-model="selectedDates"
                          type="datetimerange"
                          value-format="yyyy-MM-ddTHH:mm:ssZ"
                          range-separator=">"
                          :start-placeholder="$t('event.textbox.datePickerStart')"
                          :end-placeholder="$t('event.textbox.datePickerEnd')"
                        ></el-date-picker>
                        <div style="display: flex; width: 100%">
                          <div style="display: flex; flex: 1">
                            <span class="error" style="text-align: center">{{
                              $errorMessage("startDate", validationErrors)
                            }}</span>
                          </div>
                          <div style="display: flex; flex: 1">
                            <span class="error" style="text-align: center">{{
                              $errorMessage("endDate", validationErrors)
                            }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12" style="margin-top: 15px">
                        <div class="row m-0">
                          <div class="col-md-6 pl-0" style="margin-top: 15px">
                            <el-alert
                              :title="$t('liveSessions.liveActive')"
                              :type="form.isLive ? 'success' : 'warning'"
                              :closable="false"
                              :description="$t('liveSessions.activationDesc')"
                              :show-icon="false"
                            >
                              <div slot="title">
                                <p
                                  style="
                                    color: rgb(3, 101, 140);
                                    font-size: 16px;
                                  "
                                >
                                  {{this.$t('liveSessions.liveActive')}}
                                </p>
                                <el-switch
                                  v-model="form.isLive"
                                  :active-text="$t('event.variables.yes')"
                                  :inactive-text="$t('event.variables.no')"
                                ></el-switch>
                              </div>
                            </el-alert>
                          </div>

                          <div class="col-md-6 pr-0" style="margin-top: 15px">
                            <el-alert
                              :title="$t('stat')"
                              :type="form.isActive ? 'success' : 'error'"
                              :closable="false"
                              :description="$t('liveSessions.statusDesc')"
                              :show-icon="false"
                            >
                              <div slot="title">
                                <p
                                  style="
                                    color: rgb(3, 101, 140);
                                    font-size: 16px;
                                  "
                                >
                                  {{this.$t('stat_')}}
                                </p>
                                <el-switch
                                  v-model="form.isActive"
                                  :active-text="$t('event.table.active')"
                                  :inactive-text="$t('event.table.passive')"
                                ></el-switch>
                              </div>
                            </el-alert>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div
                    class="col-md-6 justify-content-center d-flex flex-column"
                  >
                    <h4>{{this.$t('addVimeo')}}</h4>
                    <div class="row" style="margin-top: 20px">
                      <div class="col-md-6">
                        <label class="d-block">{{this.$t('event.table.title')}}</label>
                        <el-input v-model="item.title"></el-input>
                      </div>
                      <div class="col-md-6">
                        <label class="d-block">URL</label>
                        <el-input v-model="item.url"></el-input>
                      </div>

                      <div class="col-md-12" style="margin-top: 15px">
                        <label class="d-block">{{this.$t('event.tags.description')}}</label>
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="item.description"
                        ></el-input>
                      </div>
                    </div>

                    <div class="text-right mt-3">
                      <el-button type="primary" @click="addVimeo()"
                        >{{$t('event.components.participants.navbar.add')}}</el-button
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h4 style="font-size: 16px">{{this.$t('addedBr')}}</h4>
                    <draggable v-model="vimeoItems" v-bind="dragOptions">
                      <transition-group type="transition" name="flip-list">
                        <div
                          class="list-group-item"
                          v-for="(item, index) in $store.state.livesessions
                            .vimeoItems"
                          :key="index + 1"
                          style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            padding: 5px 5px;
                            box-shadow: -1px 2px 6px rgba(0, 0, 0, 0.1);
                            margin-bottom: 5px;
                          "
                        >
                          <div
                            style="
                              margin-left: 10px;
                              display: flex;
                              flex-direction: column;
                              flex: 1;
                            "
                          >
                            <h4>
                              <strong>{{ item.title }}</strong>
                            </h4>
                            {{ item.url }}
                          </div>

                          <el-button
                            v-if="vimeoItems.some((k) => k.id == item.id)"
                            @click="deleteSelectedItem(item)"
                            type="danger"
                            icon="el-icon-close"
                            circle
                          ></el-button>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0;
                  "
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button
                        slot="reference"
                        type="danger"
                        icon="fas fa-trash"
                        >{{ $t('event.table.delete') }}</el-button
                      >
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="
                      display: flex;
                      flex: 1;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                        >{{$t('event.buttons.close')}}</el-button
                      >
                      <el-button type="success" @click="save">{{$t("event.buttons.save")}}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 10px 0px;
      "
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="addVenueModal"
      :title="$t('event.tags.addCheckpoint')"
      width="80%"
      :append-to-body="true"
    >
      <VenueAddUpdate
        @closeMe="addVenueModal = false"
        @itemAdded="itemAddedVenue"
        :data="null"
      />
    </el-dialog>
    <el-dialog
      width="80%"
      :append-to-body="true"
      :visible.sync="sceneModal"
      :title="$t('message.scenes')"
    >
      <Scenes />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import draggable from "vuedraggable";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import DayAddUpdate from "./DayAddUpdate";
import SaloonAddUpdate from "./SaloonAddUpdate";
import SubEventAddUpdate from "./SubEventAddUpdate";
import VenueAddUpdate from "./VenueAddUpdate";
import Scenes from "./Scenes";
import $ from "jquery";
import { quillEditor } from "vue-quill-editor";
import { JSONParser } from "@amcharts/amcharts4/core";

export default {
  components: {
    ItemInfo,
    draggable,
    quillEditor,
    DayAddUpdate,
    SaloonAddUpdate,
    SubEventAddUpdate,
    VenueAddUpdate,
    Scenes,
  },
  name: "VimeoLiveSessionAddUpdate",
  data() {
    return {
      form: {
        id: null,
        title: null,
        image: null,
        startDate: null,
        endDate: null,
        youtubeURL: null,
        rmtpUrl: null,
        orderNO: 0,
        isLive: true,
        isActive: true,
        vimeoItems: [],
        venueID: null,
        backgrounBanner: null,
        topBanner: null,
        bottomBanner: null,
        isRecording: true,
      },
      item: {
        title: "",
        description: "",
        url: "",
      },
      vimeoItems: [],
      textarea: null,
      addNewSubEvent: false,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      addGroupModal: false,
      addNewDay: false,
      addNewSaloon: false,
      addVenue: false,
      selectedDates: [],
      sceneModal: false,
      addVenueModal: false,
    };
  },
  mounted() {
    this.$store.dispatch("getVenues");
  },
  methods: {
    async itemAddedVenue(item) {
      await this.$store.dispatch("getVenues");
      this.form.venueID = item;
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data;
      }
    },
    /* deleteItem() {
      var index = this.$store.state.livesessions.vimeoItems.findIndex(
        (k) => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
 */
    deleteSelectedItem(item) {
      var index = this.vimeoItems.indexOf(item);
      this.videoItems = this.vimeoItems.splice(index, 1);
      this.$store.state.livesessions.vimeoItems = this.vimeoItems;
    },

    addVimeo() {
      if(this.item.title != "" && this.item.description != "" && this.item.url != ""){
        this.vimeoItems.push({
          title: this.item.title,
          description: this.item.description,
          url: this.item.url,
        });
      } else {
        this.$message.error(this.$t('message.fill'))
      }
      
      this.$store.state.livesessions.vimeoItems = this.vimeoItems;
      this.item = {
        url: "",
        title: "",
        description: "",
      };            
    },


    save() {
      console.log(this.form.vimeoItems)
      this.validationErrors = [];
      
      this.form.vimeoItems = this.vimeoItems;
      if(this.$store.state.livesessions.vimeoItems.length > 0) {
        axios
        .post("livestream/addorupdate", {
          ...this.form,
          startDate: this.selectedDates[0],
          endDate: this.selectedDates[1],
        })
        .then((res) => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded");
              this.form = {
                id: null,
                title: null,
                image: null,
                startDate: null,
                endDate: null,
                youtubeURL: null,
                rmtpUrl: null,
                orderNO: 0,
                isLive: true,
                isActive: true,
                vimeoItems: [],
                venueID: null,
                backgrounBanner: null,
                topBanner: null,
                bottomBanner: null,
                isRecording: true,
              };
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }
        });
      } else {
        this.$message.error(this.$t('message.vimeo'));
      }
      
    },
  },
  computed: {
    getVenues() {
      if (this.form.subEventID != null && this.form.subEventID != "") {
        return this.$store.state.venues.items.filter((k) => k.type == 3);
      }
      return this.$store.state.venues.items;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    isSubEventDisabled() {
      if (this.form.venueID == null || this.form.venueID == "") return false;
      var venue = this.$store.state.venues.items.find(
        (k) => k.id == this.form.venueID
      );
      return venue.type != 3;
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}

#vimeo-live-session-add-update .el-carousel__container {
  height: 200px;
}
</style>
<style scoped>
.scenes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.scenes .scene {
  background-size: cover;
  display: flex;

  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  overflow: hidden;
  height: 150px;
}

.scene-wrapper {
  width: 100%;
  background-color: grey;
  margin: unset;
}

.scene .background {
  display: flex;
  flex: 1;
  background: green;
  height: 100%;
  width: 100%;
}

.scene .banner {
  height: 40px;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/VimeoLiveSessionAddUpdate.vue